import * as React from "react";
import * as cn from "classnames";

import styles = require("./style.less");

export class DataTableToolsRow extends React.Component<any, any> {
    render() {
        return (
            <tr className={cn(this.props.className, styles.dataTableToolsRow)}>
                {this.props.children}
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DataTable/DataTableToolsRow.tsx